const ONSPACE_TAB_KEY = 'onspace-cms-tab-session'

let sessionId = sessionStorage.getItem(ONSPACE_TAB_KEY)
if (!sessionId) {
  sessionId = crypto.randomUUID()
  sessionStorage.setItem(ONSPACE_TAB_KEY, sessionId)
}

document.addEventListener('turbo:before-fetch-request', (event) => {
  event.detail.fetchOptions.headers['X-Onspace-Tab-Session'] = sessionId
})
